import { makeSceneDoc } from '../kit.js';

/**
 * 瓦舍街：夜里的另一座城。
 * 瓦舍、废品收购站、牲口市都挤在这一带，白天看着破，天一黑就活了。
 */
export const funStreetDoc = makeSceneDoc({
  id: 'fun_street',
  name: '瓦舍街',
  region: 'city',
  tier: 2,
  node: 'fun_street',
  desc: '地上有点黏，招牌却是这城里最亮的。',
  w: 44, h: 26,
  fill: '=',
  spawn: { gx: 40, gy: 14 },
  draw(b, rng) {
    b.rect(0, 0, 44, 26, '=');
    b.rect(0, 0, 44, 2, ',');
    b.rect(0, 24, 44, 2, ',');
    // 木地板只铺房子坐的那几格，门前留一格门槛，别让人绕到屋后头去
    b.rect(2, 3, 10, 7, 'o');                      // 瓦舍门前
    b.rect(5, 7, 4, 2, '.');       b.set(6, 9, '+');
    b.rect(30, 3, 12, 7, 'o');                     // 废品站门前
    b.rect(35, 7, 4, 2, '.');      b.set(36, 9, '+');
    b.rect(2, 16, 12, 7, 'o');                     // 牲口市门前
    b.rect(5, 20, 4, 2, '.');      b.set(6, 22, '+');
    b.rect(26, 16, 10, 7, 'o');
    b.scatter(':', 26, { rng, area: [12, 11, 20, 12] });
  },
  props: [
    { type: 'stage', gx: 5, gy: 4 },
    { type: 'jokes_stalls', gx: 12, gy: 9 },
    { type: 'liquor_flag', gx: 16, gy: 6 },
    { type: 'dining_table', gx: 22, gy: 12 },
    { type: 'dining_table', gx: 24, gy: 12 },
    { type: 'gambling_mat', gx: 18, gy: 18 },
    { type: 'junkyard_scale', gx: 34, gy: 9 },
    { type: 'pet_cage', gx: 10, gy: 20 },
    { type: 'pet_cage', gx: 9, gy: 22 },
    { type: 'notice_board', gx: 20, gy: 22 },
    { type: 'lot_bucket', gx: 28, gy: 20 },
  ],
  portals: [
    { to: 'market', gx: 42, gy: 14, spawn: [2, 20], label: '市集' },
    { to: 'fun_room', gx: 6, gy: 9, spawn: [10, 14], label: '瓦舍' },
    { to: 'junkyard', gx: 36, gy: 9, spawn: [8, 14], label: '废品收购站' },
    { to: 'pet_shop', gx: 6, gy: 22, spawn: [7, 14], label: '牲口市' },
  ],
});

export default funStreetDoc;
